import {
  LabelCategoryRecord,
  LabelRecord,
} from '@trustero/trustero-api-web/lib/label/label_pb'
import { DropdownItemType } from '../IndexPage/FilterBar/FilterDropdowns/FilterDropdown.constants'

export type LabelGroup = {
  name: string
  labels: DropdownItemType[]
}

export const UNCATEGORIZED_LABEL_GROUP = 'Uncategorized'

// Labels as filter options grouped under their categories, in category order, with
// labels outside any category last. With no categories in use, it is one unnamed group.
export const groupLabelsByCategory = (
  labels: LabelRecord[],
  categories: LabelCategoryRecord[],
): LabelGroup[] => {
  const categoryName = new Map(
    categories.map((category) => [category.getId(), category.getName()]),
  )
  const groups = new Map<string, DropdownItemType[]>()
  const uncategorized: DropdownItemType[] = []
  labels.forEach((label) => {
    const item = { value: label.getId(), label: label.getName() }
    const group = categoryName.get(label.getCategoryId())
    if (group) {
      groups.set(group, [...(groups.get(group) ?? []), item])
    } else {
      uncategorized.push(item)
    }
  })
  const grouped = Array.from(groups.entries()).map(([name, items]) => ({
    name,
    labels: items,
  }))
  if (!uncategorized.length) return grouped
  return [
    ...grouped,
    {
      name: grouped.length ? UNCATEGORIZED_LABEL_GROUP : '',
      labels: uncategorized,
    },
  ]
}
